import { createSelector } from 'reselect';
import { ARCHIVED } from 'modules/queues/constants/queueEnforcementTypes';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { getAppointmentsByQueueType } from 'modules/queues/common/selectors/appointmentsByQueueType';

export const canFetchMoreAppointments = state => {
  const { byId, fetchMoreStatus } = getAppointmentsByQueueType(state);
  const totalCount = state.queues.common.appointmentInfo.queuesSize[ARCHIVED];

  return byId.length < totalCount && fetchMoreStatus !== requestsStatuses.pending;
};

export const scrollToIndex = createSelector(
  state => state.queues.archive.archiveAppointments.byId,
  state => state.queues.archive.appointmentsScroll.scrollToAppointmentId,
  (appointments, scrollToAppointmentId) => appointments.findIndex(appointmentId => appointmentId === scrollToAppointmentId),
);
